export enum AppAction {
    INIT_STORE = 'ROUTER_CHANGE/APP/INIT_STORE',
    SET_LOADING = 'ROUTER_CHANGE/APP/SET_LOADING',
    SET_ROUTERS = 'ROUTER_CHANGE/APP/SET_ROUTERS',
    SET_DISABLE_BOOKING = 'ROUTER_CHANGE/APP/SET_DISABLE_BOOKING',
    SET_PUBLIC_FACT_NAME = 'ROUTER_CHANGE/APP/SET_PUBLIC_FACT_NAME',
    SET_CUSTOMER_TYPE = 'ROUTER_CHANGE/APP/SET_CUSTOMER_TYPE',
    SET_SELECTED_ROUTER = 'ROUTER_CHANGE/APP/SET_SELECTED_ROUTER',
    SET_AVAILABLE_ROUTER_IDS = 'ROUTER_CHANGE/APP/SET_AVAILABLE_ROUTER_IDS',
    SET_PROVIDER_TYPE = 'ROUTER_CHANGE/APP/SET_PROVIDER_TYPE',
    SET_ERROR = 'ROUTER_CHANGE/APP/SET_ERROR',
    SET_CUSTOMER = 'ROUTER_CHANGE/APP/SET_CUSTOMER',
    SET_IS_MOBILE_OR_NON_VF = 'ROUTER_CHANGE/APP/SET_IS_MOBILE_OR_NON_VF'
}

export enum ErrorType {
    CMS_CONFIG = 'CMS Config error',
    JARVIS = 'Jarvis error',
    AVC = 'Availability Check error',
}

export enum ProviderType {
    UM = 'UM',
    VKD = 'VKD'
}
